import '../snippets/product-gallery.js';
import '../components/back-in-stock.js';
import { getOmnibusPriceFromAPI, renderOmnibusPriceFromAPI, createOmnibusEndpoint } from '../vendor/omnibus.js';
import Cookies from 'js-cookie';

$(function () {
  $('.product-template').on('variantChange', function (e) {
    if (e.variant) {

      var percentage;
      percentage = ((e.variant.compare_at_price - e.variant.price) * 100) / e.variant.compare_at_price;
      percentage = Math.ceil(percentage);

      $('[data-variant-sku]').html(e.variant.sku);

      if ($('.product__discount .percentage').length > 0) {
        $('.product__discount .percentage .percentage-val').empty().html(percentage);
      }

      if ($('.stripbar-pdp').length > 0) {
        $('.stripbar-pdp__product-compared_price , .stripbar-pdp__product-price').remove();
        var wrapper_price,
          price_html,
          variant,
          price,
          suffix;

        wrapper_price = $('.stripbar-pdp__product-wrapper-price');
        variant = e.variant.compare_at_price / 100;
        price = e.variant.price / 100;
        suffix = wrapper_price.attr('data-sale-suffix');

        if (!!e.variant.compare_at_price) {
          price_html = '<span class="stripbar-pdp__product-compared_price">';
          price_html += '<span class="stripbar-pdp__product-strike-price">' + window.theme.Currency.formatMoney(variant.toFixed(2), window.theme.strings.moneyFormat) + '</span>';
          price_html += '<span class="stripbar-pdp__product-price">' + window.theme.Currency.formatMoney(price.toFixed(2), window.theme.strings.moneyFormat) + '</span>';
          price_html += '<span class="stripbar-pdp__product-percentage">';
          price_html += percentage + '% ';
          price_html += suffix;
          price_html += '</span>';
          price_html += '</span>';
        } else {
          price_html = '<span class="stripbar-pdp__product-price">';
          price_html += window.theme.Currency.formatMoney(price.toFixed(2), window.theme.strings.moneyFormat);
          price_html += '</span>';
        }

        wrapper_price.html(price_html);
      }
    }
  });

  // Recently viewed products cookies implementation

  if (document.cookie.indexOf('_iub_cs') != -1) {
    var iubenda_id = document.cookie.split('_iub_cs-')[1].split('=')[0];
    var iubenda_cookie = JSON.parse(Cookies.get('_iub_cs-' + iubenda_id));
    var recently_vw_cookie, current_product;
    var max_products = 12;

    if (iubenda_cookie.purposes["5"] && iubenda_cookie.purposes["1"]) {
      recently_vw_cookie = Cookies.get('RECENTLY_VIEWED') != undefined ? Cookies.get('RECENTLY_VIEWED').split(',') : [];

      if (recently_vw_cookie.indexOf(current_product) == -1) {
        current_product = window.location.href.split('?')[0].split('products/')[1];

        if (recently_vw_cookie.unshift(current_product) > max_products) {
          recently_vw_cookie.pop();
        }
        Cookies.set('RECENTLY_VIEWED', recently_vw_cookie.join(','));
      }
    }
  }
});


(function () {
  const renderOmnibusPrice = async function (container, vId = false, vPrice = false, vHasPromo = false) {
    const variantID = vId || container.getAttribute('data-omnibus_id');
    const variantPrice = vPrice || container.getAttribute('data-variant_price');
    const brand = container.getAttribute('data-omnibus_brand');
    const hasPromo = vHasPromo || container.getAttribute('data-has_promo');

    renderOmnibusPriceFromAPI(container, await getOmnibusPriceFromAPI(brand, variantID), variantPrice, hasPromo);
  }

  const getOBContainers = function () {
    const omnibusContainers = document.querySelectorAll('[data-omnibus_price-container]');
    const OBContainersByEndpoint = {}

    if (omnibusContainers && omnibusContainers.length) {
      const OBContainers = Array.prototype.slice.call(omnibusContainers);

      OBContainers.map(container => {
        const currentID = container.getAttribute('data-omnibus_id');
        const currentBrand = container.getAttribute('data-omnibus_brand');
        const currentEndpoint = createOmnibusEndpoint(currentBrand, currentID);

        if (!OBContainersByEndpoint[currentEndpoint]) OBContainersByEndpoint[currentEndpoint] = [];
        OBContainersByEndpoint[currentEndpoint].push(container);
      });
    }

    return OBContainersByEndpoint;
  }

  const OBContainersByEndpoint = getOBContainers();

  for (const [endpoint, containers] of Object.entries(OBContainersByEndpoint)) {
    for (let i = 0; i < containers.length; ++i) {
      renderOmnibusPrice(containers[i]);
    }
  }

  const productTemplateSection = document.getElementById('ProductSection--template_product');
  if (productTemplateSection) {
    productTemplateSection.addEventListener('variantChange', function (e) {
      if (e.variant) {
        const OBContainersByEndpoint = getOBContainers();

        for (const [endpoint, containers] of Object.entries(OBContainersByEndpoint)) {
          for (let i = 0; i < containers.length; ++i) {
            renderOmnibusPrice(containers[i], e.variant.id, e.variant.price);
          }
        }
      }
    });
  }
})();
